import React from 'react';
import { MobilePodiumCard } from '../MobilePodiumCard';
import { RankRow } from '../RankRow';
import styles from './MobileTopSection.module.scss';

export const MobileTopSection = ({ id, title, players = [], onViewAll, viewAllLabel }) => {
  const top3 = players.filter(p => p.rank <= 3);
  const rankList = players.filter(p => p.rank >= 4 && p.rank <= 10);

  return (
    <section id={id} className={styles.section}>
      <h2 className={styles.title}>{title}</h2>

      <div className={styles.podiumList}>
        {top3.map(player => (
          <MobilePodiumCard key={player.rank} {...player} />
        ))}
      </div>

      <div className={styles.rankList}>
        {rankList.map(player => (
          <RankRow key={player.rank} {...player} />
        ))}
      </div>

      <button type="button" onClick={onViewAll} className={styles.viewAll}>
        {viewAllLabel}
      </button>
    </section>
  );
};
